<template>
    <div>
        <v-row justify="center" class="bg-color-teal-900">
            <v-col cols="0" sm="2"></v-col>
            <v-col cols="12" sm="8">
                <v-row>
                    <v-container>
                        <div class="body-text text-white mt-4">
                            <p class="text-h4 font-weight-light">
                                <LanguagePlaceholder is-html default-text="Distributor E-Voucher Report" />
                            </p>
                            <br />
                            <p>
                                <b>WHAT is this report: </b>
                                Distributor E-Voucher report shows all of the e-vouchers that partners have selected to spend with you. This is a live report. 
                                <br /><br />
                                <b>HOW do you use it: </b>
                                The E-Voucher Status column will tell you if the partner has purchased the E-voucher from the RISE portal (Rewards Redeemed), if they have used the E-voucher with you (<b>Utilized</b>), if they did not use their E-voucher on time (<b>Expired</b>) or if the E-Voucher was cancelled (<b>Cancelled</b>). The Payment Reference column will show you OF the Utilized E-Vouchers, what your corresponding Credit Note Number is so you can track if you have been reimbursed for the spend. NOTE: Credit Note reimbursements take approximately 6 weeks from the date you reported it into Zyme (E2open).
                                <span style="font-weight: bolder; font-size: large;">
                                    <br /><br />
                                    Please contact support@dellpartnerincentives.com if you have any queries relating to credit note numbers.
                                    <br /><br />
                                    Please click <a 
                                    class="text-decoration-none red-link"
                                        href="https://dellpartnerincentives.com/comms/RISE%20Assets/Distributor/RISE%20Distributor%20Introductory%20Guide.pdf"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                    >

                                    <u>HERE</u></a> for more information on the Redemption and Credit Note process.
                                </span>
                            </p>        
                            <PleaseNote></PleaseNote>
                        </div>
                    </v-container>
                    <v-container>
                        <v-row class="">
                            <v-col cols="12" sm="6" md="4">
                                <div class="d-flex ga-5">
                                    <v-switch 
                                        v-model="isSelectByQuarter"
                                        @update:modelValue="selectByQuarter"
                                        color="#9FDDFF"
                                        density="compact">
                                    </v-switch>
                                    <v-select class="text-white" label="Select Incentive Period"
                                        v-model="selectedQuarters" :items="quarters" variant="outlined" multiple chips
                                        closable-chips
                                        aria-label="Select one or more incentive periods"
                                        :disabled="!isSelectByQuarter">
                                        <template v-slot:label>
                                            <LanguagePlaceholder is-html default-text="Select Incentive Period" />
                                        </template>
                                    </v-select>
                                </div>

                            </v-col>
                            <v-col cols="12" sm="6" md="4">
                                <div>
                                    <v-select clearable :items="countries" return-object v-model="selectedCountries"
                                        class="text-white" item-title="country" item-value="country" variant="outlined"
                                        multiple chips closable-chips
                                        aria-label="Select one or more locations"
                                        :disabled="!isSelectByQuarter">
                                        <template v-slot:label>
                                            <LanguagePlaceholder is-html default-text="Select Location" />
                                        </template>
                                    </v-select>
                                </div>

                            </v-col>
                        </v-row>                        
                        <v-row>
                            <v-col cols="12" sm="6" md="4">
                                <div class="d-flex ga-5">
                                    <v-switch 
                                        v-model="isSelectByNumber"
                                        @update:modelValue="selectByNumber"
                                        color="#9FDDFF"
                                        density="compact">
                                    </v-switch>
                                    <v-text-field clearable label="E-Voucher Number" class="text-white" v-model="eVouchernumber"
                                        variant="outlined" :disabled="!isSelectByNumber"></v-text-field>                                    
                                </div>
                            </v-col>
                            <v-col cols="12" sm="6" md="4">

                            </v-col>
                        </v-row>
                        <v-row class="gap-2 align-center mb-5">
                            <v-btn @click="clickSubmit" color="white" variant="outlined">
                                <LanguagePlaceholder default-text="Submit" />
                            </v-btn>
                            <v-btn class="mx-4" prepend-icon="mdi-download" @click="downloadFile" color="white" variant="outlined" aria-label="Download Report"><LanguagePlaceholder default-text="Download" /></v-btn>
                        </v-row>
                    </v-container>

                </v-row>
            </v-col>
            <v-col cols="0" sm="2"></v-col>
        </v-row>
        <v-row justify="center" style="background-color: #ffffff;" class="pb-6">
            <v-toolbar density="compact" color="#00796B">
                <v-spacer></v-spacer>
                <span style="font-weight: bolder; font-size: large;">Please mark RISE safe for pop-ups / check for pop-up blocker if you do not see your download starting immediately</span>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-container>
                <v-text-field v-model="searchString" label="Filter" prepend-inner-icon="mdi-filter-outline"
                    variant="outlined" hide-details single-line aria-label="Filter eVoucher report data"></v-text-field>
                <v-data-table items-per-page="50" :headers="headersEvouchers" :items="reportData" :search="searchString"
                    class="v-data-table" item-key="id" role="table" aria-label="Distributor eVoucher report data">
                    <template v-slot:item.eVoucherValue="{ item }">
                        {{ $filters.currencyUSD(item.eVoucherValue) }}
                    </template>
                    <template v-slot:item.eVoucherValueLocalCurrency="{ item }">
                        {{ $filters.toGenericCurrency(item.eVoucherValueLocalCurrency) }}
                    </template>
                    <template v-slot:item.downloadEVoucher="{ item }" v-if="showDownloadBtn">
                        <v-btn size="small" icon="mdi-download" @click="downloadEVoucher(item)" aria-label="Download eVoucher"></v-btn>
                    </template>
                </v-data-table>
            </v-container>
        </v-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import { useRegistrationStore } from '@/stores/registration'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'
import { useExcelStore } from '@/stores/excel'
import PleaseNote from '@/components/PleaseNote.vue'

const systemStore = useSystemStore()
const registrationStore = useRegistrationStore()
const excelStore = useExcelStore()

const quarters = ref([]);
const selectedQuarters = ref([])
const selectedCountries = ref([])
const currentQuarter = ref('')
const showDownloadBtn = ref(false)
const selectedDistributorAffinityId = ref('')
const eVouchernumber = ref('')
const isSelectByQuarter = ref(true)
const isSelectByNumber = ref(false)

const affinityId = ref(0)
const countries = ref([])
const reportData = ref([])
const searchString = ref('')

const headersEvouchers = [
    { title: 'Download E-Voucher Copy', value: 'downloadEVoucher', headerProps: { class: 'header-style' }, sortable: false },
    
    { title: 'E-Voucher Number', value: 'eVoucherNumber', headerProps: { class: 'header-style' }, sortable: true },
    { title: 'Partner Name', value: 'partnerName', headerProps: { class: 'header-style' }, sortable: true },
    { title: 'Partner Affinity Id', value: 'partnerAffinityId', headerProps: { class: 'header-style' }, sortable: true },
    { title: 'Location', value: 'partnerCountry', headerProps: { class: 'header-style' } },
    { title: 'E-Voucher Value', value: 'eVoucherValue', headerProps: { class: 'header-style' }, sortable: true },

    { title: 'Local Currency', value: 'eVoucherValueLocalCurrencyCode', headerProps: { class: 'header-style' }, sortable: true },
    { title: 'Local Value', value: 'eVoucherValueLocalCurrency', headerProps: { class: 'header-style' }, sortable: true },

    { title: 'E-Voucher Status', value: 'eVoucherStatus', headerProps: { class: 'header-style' }, sortable: true },
    { title: 'Expiry Date', value: 'expiryDate', headerProps: { class: 'header-style' }, sortable: true },
    { title: 'Payment Reference', value: 'paymentReference', headerProps: { class: 'header-style' }, sortable: true },

    

]

const selectByQuarter = () => {
    if (isSelectByQuarter.value === true) {
        isSelectByNumber.value = false
        
        selectedCountries.value = []
        eVouchernumber.value = ''

        selectedQuarters.value = quarters.value.length ? [quarters.value[0]] : []
    }
    else {
        isSelectByNumber.value = true
        selectedQuarters.value = []
        selectedCountries.value = []
    }
}

const selectByNumber = () => {
    if (isSelectByNumber.value === true) {
        isSelectByQuarter.value = false
        
        selectedQuarters.value = []
        selectedCountries.value = []
        eVouchernumber.value = ''
    }
    else {
        isSelectByQuarter.value = true
        selectedQuarters.value = quarters.value.length ? [quarters.value[0]] : []
        eVouchernumber.value = ''
    }
}

onMounted(() => {
    affinityId.value = systemStore.userDetail.affinityId

    systemStore.getQuarters().then(result => {
        if (result.success) {
            quarters.value = result.quarters
                .filter(q => q.currentRedemptionQuarter === true || q.previousRedemptionQuarters === true)
                .map(q => q.quarter)

            const cq = result.quarters.find(q => q.currentRedemptionQuarter === true)?.quarter
            selectedQuarters.value = cq ? [cq] : []
            currentQuarter.value = cq
        }
    }).catch(error => {
        console.log('recalculateLocalValue', error)
    })

    registrationStore.GetEMEACountries().then(result => {
        countries.value = result.countries
    }).catch(error => {
        console.log('disti dashb get countries', error)
    })
})

const downloadEVoucher = (item) => {
    systemStore.downloadDistributorEVoucher(item.eVoucherNumber).then(res => {
        systemStore.openPdfInNewWindow(res.base64Pdf, "EVoucher_" + item.eVoucherNumber + ".pdf")
    }).catch(error => {
        console.log(error)
    })
}


const base64ToArrayBuffer = (_base64Str) => {
    var binaryString = window.atob(_base64Str);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}


const downloadFile = () => {
    if (reportData.value.length === 0) {
        return
    }

    excelStore.generateInMemoryExcelDocument(reportData.value, 'DistibutorEvoucherDocument').catch(error => {
        console.log('Generate In Memory Excel Document - DistibutorEvoucherDocument', error)
    })
}

const selectedQuarterValues = () => {
    const v = selectedQuarters.value
    if (v == null) {
        return []
    }
    return Array.isArray(v) ? v : [v]
}

const selectedCountryValues = () => {
    const v = selectedCountries.value
    if (v == null) {
        return []
    }
    const arr = Array.isArray(v) ? v : [v]
    return arr
        .map((item) => {
            if (item == null) {
                return ''
            }
            if (typeof item === 'object' && item.country != null) {
                return String(item.country)
            }
            return String(item)
        })
        .filter((c) => c !== '')
}

const clickSubmit = () => {
    const qs = selectedQuarterValues()
    showDownloadBtn.value =
        Boolean(currentQuarter.value) && qs.includes(currentQuarter.value)
    getReportData()
}

const getReportData = () => {

    eVouchernumber.value = eVouchernumber.value != null ? eVouchernumber.value : ''

    systemStore.getDistributorEVoucherReport(selectedQuarterValues(), selectedCountryValues(), eVouchernumber.value).then(result => {
        reportData.value = []
        if (result.success === true) {
            reportData.value = result.evouchers
        }
    }).catch(error => {
        console.log('distributor evoucher report, get data', error)
    })
}


</script>

<style>
.header-style {

    /* background-color: #012a4b; */
    background-color: #012a4b;
    color: white;
}

.v-data-table tbody tr:nth-child(even) {
    background-color: #e0e6ec;
    color: #202520;
}

.v-data-table tbody tr:nth-child(odd) {
    background-color: whitesmoke;
    color: #252020;
}
</style>
